import { useCallback, useMemo } from 'react';
// eslint-disable-next-line
import WorkerChat from 'worker-loader!../workers/chat.worker.js';
/**
 * @typedef {Function} useWorker
 * @returns {{
 *  sendMessageWork: (data: unknown) => void,
 *  addMessageListener: (callback: (data: unknown) => void) =>
 * }}
 */
export function useWorker() {
  const worker = useMemo(() => new WorkerChat(), []);

  // Função para enviar mensagens para o worker
  const sendMessageWork = useCallback((data) => {
    if (window.Worker) {
      const jsonString = JSON.stringify(data);
      const buffer = new TextEncoder().encode(jsonString).buffer;
      worker.postMessage(buffer);
    }
  }, []);

  // Função para adicionar listener de mensagens
  const addMessageListener = useCallback((callback) => {
    if (window.Worker)
      worker.onmessage = (e) => {
        callback(e.data);
      };
  }, []);

  return { sendMessageWork, addMessageListener };
}
